import { fetchRulesTargetingSameMetafield, isNamespaceAndKeyValid } from '../common/Helpers';

export function createClashingRulesValidationFunction(metafieldOwnerType, metafieldFieldName) {

    return function (rule, errors, onAsyncError) {

        if (this.timeoutId != null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }

        if (!isNamespaceAndKeyValid(rule[metafieldFieldName])) {
            return;
        }

        this.timeoutId = setTimeout(() => {
            fetchRulesTargetingSameMetafield(metafieldOwnerType, rule[metafieldFieldName], rule.id)
                .then(response => response.json())
                .then(data => {
                    if (data.length > 0) {
                        errors[metafieldFieldName] = `This metafield is being used by another rule. Multiple rules targeting the same metafield are not allowed. Please contact support to resolve the problem. Rules using the same metafield: ${data.map(_ => (_.ruleName)).join(", ")}`;
                        onAsyncError(errors);
                        this.timeoutId = null;
                    }
                });
        }, 1000
        );
    };
}

export function createClashingRulesValidationFunctionNew(metafieldOwnerType) {

    return function (rule, errors, onAsyncError) {

        if (this.timeoutId != null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }

        const metafieldName = rule.settings["metafieldNamespaceAndKey"];
        if (!isNamespaceAndKeyValid(metafieldName)) {
            return;
        }

        this.timeoutId = setTimeout(() => {
            fetchRulesTargetingSameMetafield(metafieldOwnerType, metafieldName, rule.id)
                .then(response => response.json())
                .then(data => {
                    if (data.length > 0) {
                        errors["metafieldNamespaceAndKey"] = `This metafield is being used by another rule. Multiple rules targeting the same metafield are not allowed. Please contact support to resolve the problem. Rules using the same metafield: ${data.map(_ => (_.ruleName)).join(", ")}`;
                        onAsyncError(errors);
                        this.timeoutId = null;
                    }
                });
        }, 1000
        );
    };
}

export function createValidator(onAsyncError, validationRules, validateAsync) {

    var validator = {
    };

    if (validateAsync == null) {
        validateAsync = () => { };
    }

    validator.validateAsync = validateAsync.bind(validator);

    const validate = function (rule) {

        let errors = {};

        if (rule == null) {
            return errors;
        }

        validationRules.forEach(validation => validation(rule, errors));
        this.validateAsync(rule, errors, onAsyncError);

        return errors;
    }

    validator.validate = validate.bind(validator);

    return validator;
}

export function defaultValidationMetafieldRule(rule, errors) {

    if (rule.name == null || rule.name === "") {
        errors["name"] = "Name is required.";
    }

    if (rule.trigger == null || rule.trigger === "") {
        errors["trigger"] = "Trigger is required.";
    }

    if (rule.settings.metafieldType == null || rule.settings.metafieldType === "") {
        errors["metafieldType"] = "Metafield type is required.";
    }

    if (rule.settings.metafieldNamespaceAndKey == null || rule.settings.metafieldNamespaceAndKey === "") {
        errors["metafieldNamespaceAndKey"] = "Metafield namespace and key is required.";
    }

    if (rule.settings.metafieldNamespaceAndKey != null && !/^(.+\..+)$/.test(rule.settings.metafieldNamespaceAndKey)) {
        errors["metafieldNamespaceAndKey"] = "Incorrect namespace and key.";
    }
}

export function defaultValidationTagRule(rule, errors) {

    if (rule.name == null || rule.name === "") {
        errors["name"] = "Name is required.";
    }

    if (rule.trigger == null || rule.trigger === "") {
        errors["trigger"] = "Trigger is required.";
    }
}

export const ruleDefinitionDefaults = {
    ruleType: "RuleType",
    title: "Default Title",
    description: "Default Descriptions",
    legacy: false,
    inProgress: false,
    tags: ["Products", "Tags"],
    dataPermissions: ["products"],
    getDefaultRuleState: () => {
        return {}
    }
}